<template>
  <v-row>
    <v-col cols="auto">
      <div class="d-flex align-center">
        <v-btn
          icon
          class="mr-2"
          @click="goBack"
        >
          <v-icon small>
            fa-light fa-chevron-left
          </v-icon>
        </v-btn>

        <div
          v-if="player.loading"
          class="d-flex align-center"
        >
          <div class="d-flex align-center">
            <v-skeleton-loader
              type="text"
              width="120"
              height="16"
              class="my-0"
              style="line-height: 1;"
            />
          </div>
          <span class="mx-2 mb-1 grey--text">/</span>
          <div class="d-flex align-center">
            <v-skeleton-loader
              type="text"
              width="80"
              height="16"
              class="my-0"
              style="line-height: 1;"
            />
          </div>
        </div>

        <div
          v-else
          class="d-flex align-center"
        >
          <router-link
            :to="{ name: RouteNames.PLAYER_DETAILS, params: { playerId: player.data.id } }"
            class="text-decoration-none primary--text font-weight-medium"
          >
            {{ player.data.first_name }} {{ player.data.last_name }}
          </router-link>
          <span class="mx-2 grey--text">/</span>
          <span class="grey--text text--darken-2 font-weight-medium">{{ viewName }}</span>
        </div>
      </div>
    </v-col>
    <v-col>
      <slot />
    </v-col>
  </v-row>
</template>

<script>
import { RouteNames } from '@/router/routes'

export default {
  name: 'PlayerBreadcrumb',
  props: {
    player: {
      type: Object,
      required: true
    },
    view: {
      type: String,
      required: true
    }
  },
  computed: {
    RouteNames() {
      return RouteNames
    },
    viewName() {
      return this.view
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ')
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
</style>
